import { useEffect, useState } from "react";
import { _DocumentatioPage, _single, _SystemPropertyOB } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { PrintJson } from "../../theme/Component/PrintJson";
import { Modal } from "../../theme/Component/Modal";
import { ExportXLSL } from "../../theme/Component/ExportXLSX";
import { BasicButton } from "../../theme/Component/BasicButton";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM, MODAL_XL } from "../../theme/Component/hooks/useModal";
import { ImportXLSX } from "../../theme/Component/ImportXLSX";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { Alert } from "../../theme/Component/Alert";

export const DocumentDocsManager = () => {

    const { instance, bean, setBean } = useDataBean(_DocumentatioPage);
    const propertie = useDataBean(_SystemPropertyOB);

    const [listImport, setListImport] = useState<any[]>([]);
    const [listErrImport, setListErrImport] = useState<any[]>([]);

    const importM = useModal("Importar Listado de Documentos", MODAL_md);
    const exportM = useModal("Exportar Listado de Documentos", MODAL_SM);
    const modalC = useModal("Eliminar Documentación", MODAL_SM);
    const modal = useModal("", MODAL_XL);
    const modalInfo = useModal("Excepciones de la importación", MODAL_LG);


    const [idAdmin, setIDAdmin] = useState<number>();
    const [response, setResponse] = useState<any>("");
    const [lista, setLista] = useState<any[]>([]);

    useEffect(() => {
        getLista();

        propertie.instance.getSystemProperty("AdmindID").then(
            (resp) => {
                setIDAdmin(resp.SystemValue)
            }
        ).catch(err => { console.log(err) });
    }, [])



    const getLista = () => {
        instance.getPageDocumentationRender(null, null, null).then(
            (resp) => {
                setLista(resp.List)
            }
        ).catch(
            err => {
                console.log(err)
                toast.error("No se pudo cargar la lista de documentos")
            }
        )
    }

    const head = [
        { title: 'URLMenu', property: 'ApplicationIDUrl', visible: true },
        { title: 'ID de la Pagina', property: 'IDBookPage', visible: true },
        { title: 'Nombre de Paigna', property: 'PageName', visible: true },
        { title: 'Empleado', property: 'EntityName', visible: true },
        { title: 'Ultima Actualización', property: 'LastUpdate', visible: true },
    ]


    // MARK: Impportar
    const importMenu = async () => {
        console.log(listImport);
        setListErrImport([]);
        let existe: string[] = [];
        let errores: string[] = [];

        lista.forEach(element => {
            existe.push(element.DataBeanProperties.PageName.trim());
        });

        for (let index = 1; index < listImport.length; index++) {
            let row = listImport[index];

            const pageName = row[2]?.trim();
            const applicationUrl = row[0]?.trim();

            const yaExiste = lista.some(item => {
                const p = item.DataBeanProperties;
                return (
                    p.PageName?.trim() === pageName &&
                    p.ApplicationIDUrl?.trim() === applicationUrl
                );
            });

            if (!yaExiste) {
                const obj = {
                    ApplicationIDUrl: applicationUrl,
                    IDBookPage: row[1],
                    PageName: pageName,
                    LastUpdate: _single.getCurrenDate(),
                    IDEmployee: idAdmin
                };

                try {
                    await instance.updateDocumentatioPage(obj).then(
                        (resp) => {
                            console.log(resp)
                            toast.success(`Documento ${row[2]} creado: ${index + 1}`)
                        }
                    )
                } catch (err) {
                    console.log(`Error en la fila ${index}:`, err);
                    toast.error(`Error al crear el item en la fila ${index}`);
                    errores.push(`${index} - ${applicationUrl}`);
                }
            } else {
                errores.push(`Ya existe el documento ${pageName} en la url ${applicationUrl}`)
            }

        }


        await getLista();

        importM.close();

        if (errores.length > 0) {
            toast.error("Las siguientes incidencias Ocurrieron en el proceso");
            setListErrImport(errores);
            modalInfo.open();
        }
    };

    const getDocumentInfo = (idPage: number) => {
        instance.getPageDocumentationHtml(idPage).then(
            (resp) => {
                setResponse(resp);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const deleteItem = () => {
        instance.deleteDocumentatioPage(bean.IDDocumentatioPage).then(
            (resp) => {
                getLista();
                modalC.close();
            }
        ).catch(
            err => { toast.error(err) }
        )
    };

    useEffect(() => {
        if (response != "") {
            modal.open();
        }
    }, [response])

    return (
        <>
            <div className="d-flex justify-content-between">
                <BasicButton eventClick={() => exportM.open()} icon="ri-file-download-line" children={`Exportar Listado de Documentos Docs`} />

                <BasicButton icon="ri-file-upload-line" eventClick={() => importM.open()} children={`Importar Listado de Documentos Docs`} />
            </div>

            <div className="col-md-12 mt-5">
                <div className="list-group" style={{ maxHeight: "52vh", overflow: "auto" }}>

                    {Array.isArray(lista) && lista.length > 0 &&
                        lista.map((item: any, index: number) => {
                            const DataItem = item.DataBeanProperties;
                            return (
                                <div
                                    key={index}
                                    className="list-group-item d-flex justify-content-between align-items-center pointer"
                                    onClick={() => {
                                        if (DataItem.IDBookPage) {
                                            setBean(DataItem);
                                            getDocumentInfo(DataItem.IDBookPage);
                                        } else {
                                            toast.error("Validar configuración")
                                        }
                                    }}
                                >
                                    <span style={{ width: "80%", overflow: "hidden", textWrap: "nowrap" }}>
                                        <i className="ri-article-line fs-2 align-middle me-2 cursor"></i>
                                        {DataItem.ApplicationIDUrl} - {DataItem.PageName}
                                    </span>
                                    <button
                                        type="button"
                                        className="btn btn-danger btn-sm"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setBean(DataItem);
                                            modalC.open();
                                        }}
                                    >
                                        <i className="ri-close-line"></i>
                                    </button>
                                </div>
                            );
                        })
                    }

                </div>
                <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                    <strong>Eliminar Documento {bean.PageName}</strong>
                </ModalConfirm>
            </div>

            <Modal modal={importM.modal} updateModal={importM.setModal} eventModal={() => { importMenu() }}  >
                <div className="row">
                    <div className="col">
                        <ImportXLSX lodaData={setListImport} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="col-md-12">
                    <iframe
                        srcDoc={response}
                        style={{ width: "100%", height: "75vh" }}
                    />
                </div>
            </Modal>

            <Modal modal={modalInfo.modal} updateModal={modalInfo.setModal}>
                <div className="row">
                    {Array.isArray(listErrImport) && listErrImport.length > 0 &&
                        listErrImport.map((data, index) => (
                            <p key={index}>{data}</p>
                        ))
                    }
                </div>

            </Modal>

            <Modal modal={exportM.modal} updateModal={exportM.setModal}>
                {lista.length > 0 ?
                    <ExportXLSL canExport customName={"DocumentosDocs"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={lista} onExport={(name: string) => {
                        _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                    }} />
                    :
                    <Alert children={"Sin documentos que exportar"} clase="info" />
                }
            </Modal>
        </>
    )
}